import styled, { css } from 'styled-components';
import { RichText } from '@sitecore-jss/sitecore-jss-react';

import { spacing } from '_utils/props';
import {
  color,
  heading_s,
  text_s,
  svg,
  safeFocusRemoval,
  focusOutline,
  hideOnPrint
} from '_utils/styles';
import { externalLinkStyle } from "_components/Corporate/ContentRichText/StyledContentRichText";

const announcementThemes = {
  Primary: css`
    background-color: ${({ theme }) => theme.colors.background.tertiary};
  `,
  Warning: css`
    background-color: ${({ theme }) => theme.colors.all.annandaleOrangeTint110};
  `,
  'High alert': css`
    background-color: ${({ theme }) => theme.colors.all.pottsPointRedTint110};
  `
};

const handleAnnouncementTheme = ({ alertStyle }) => announcementThemes[alertStyle];

export const AnnouncementWrapper = styled.div<{ $hasDescription?: boolean; $alertStyle?: keyof typeof announcementThemes }>`
  ${({ theme }) => spacing({ theme, $p: 3 })};
  color: ${({ theme }) => theme.colors.element.white};

  ${({ $alertStyle }) => $alertStyle && announcementThemes[$alertStyle]}
  display: flex;
  align-items: ${({ $hasDescription }) => ($hasDescription ? 'flex-start' : 'center')};

  &:not(.announcement-hidden) + &:not(.announcement-hidden) {
    ${({ theme }) => spacing({ theme, $mt: 3 })};
  }

  path {
    fill: ${({ theme }) => theme.colors.element.white};
  }
  @media print {
    path {
      fill: ${({ theme }) => theme.colors.element.black};
    }
  }
`;

export const IconWrapper = styled.div`
  ${svg(20, 20)}
  width: 20px;
  flex-shrink: 0;
  position: relative;
  top: 3px;
`;

export const TextWrapper = styled.div`
  ${({ theme }) => spacing({ theme, $ml: 2 })};
  flex-grow: 1;
`;

export const TitleWrapper = styled.div`
  color: inherit;
  display: inline-block;

  &:focus {
    ${safeFocusRemoval}
    ${focusOutline}
  }
  &:hover {
    text-decoration: none;
  }

  h2 {
    ${heading_s}
    margin: 0;
  }
`;

export const Content = styled(RichText)`
  ${text_s}
  margin: 0;
  ${({ theme }) => spacing({ theme, $mt: 1 })};

  a {
    color: inherit;
    &:hover {
      text-decoration: none;
    }
  }
  .external-link {
    ${externalLinkStyle}
  }
`;

export const Trigger = styled.button`
  border: 0;
  background: none;
  padding: 0;
  cursor: pointer;
  flex-shrink: 0;
  ${({ theme }) => spacing({ theme, $ml: 1 })};
  position: relative;

  &:focus {
    ${safeFocusRemoval}
    ${focusOutline}
  }
`;

export const TriggerIconWrapper = styled.span`
  ${svg(12, 12)}
  width: 12px;
  flex-shrink: 0;
  ${hideOnPrint}
`;
